<template>
    <SubLayout
        :pageTitle="title"
        :pageBreadcrumbs="breadcrumbs"
        :hasBack="true"
    >
        <template #layoutContent>
          <form class="form w-100" id="kt_kyc_form" @submit.prevent="submitResponse">
                    <Card class="card p-5" :title="nps?.title">
                        <div class="modal-body">
                            <Card class="card p-5 justify-ceontent-center align-items-center">
                                <Label labelClass="form-label fs-3 fw-bolder" :label="nps?.nps_description" :required="true"/>
                                <NpsInput v-if="nps.icon == ICONS.EMOJI" :type="ICONS.EMOJI"/>
                                <NpsInput v-if="nps.icon == ICONS.STAR" :type="ICONS.STAR"/>
                            </Card>
                            <br>
                            <FormField
                                v-for="field in nps?.form?.fields"
                                :key="field.id"
                                :form-data="field"
                                :form-errors="formErrors"
                                :withId="false"
                                v-model="formData" /> 
                        </div>
                        <template #cardFooter> 
                           <!--  <div class="d-flex justify-content-end">
                                <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.reset" @click="resetForm"></Button>
                                <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :loading="loading" @click="handleFormSubmit"></Button>
                            </div> -->
                        </template>
                    </Card>
                </form>
        </template>
    </SubLayout>
  </template>
  
<script setup>
import {computed, nextTick, onMounted, ref, watch} from "vue";
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import {useStore} from "vuex";
import {useRouter, useRoute} from "vue-router";
import {useLocales} from "@/composables/locales";
import Card from "@/components/Card.vue";
import FormField from "@/components/Form/FormField.vue";
import { useNpsIcon } from "../../composable/useNpsIcon";
import { reactive } from "vue";
import Label from "@/components/Form/Label.vue";
import NpsInput from "../../components/Inputs/NpsInput.vue";
  
  const route = useRoute()
  const router = useRouter()
  
  const store = useStore()
  const { ICONS } = useNpsIcon()
  const { locale } = useLocales()
  
  const title = ref("breadcrumbs.nps")
  const breadcrumbs = ref([
  {
    name: 'breadcrumbs.views',
    route: 'nps'
  }
  ])
  
  const getting = ref(false)
  const loading = ref(false)

  const nps = ref({})
  const formData = reactive({})
  const formErrors = ref({})

  const defaultForm = ref({})
  
  const company = computed(() => store.getters['offices/getSelectedCompany'])
  
  watch(() => route.params.id, () => {
    if(route.params.id){
      loadNps()
    }
  })
  
  const loadNps= () => {
    getting.value = true
    store.dispatch('nps/getNps', route.params.id).then((resp) => {
      nps.value = resp.data.data
      initForm(resp.data.data)
    })
    .finally(() => getting.value = false)
  }
  
  
  function submitResponse(data){
    loading.value = true
    store.dispatch('', {...data, society_id: company?.value.id, name: data?.title})
        .then(res => {
          window.toastr['success'](i18n.global.t("notification.nps_response_submited"))
          
        })
        .catch((err) => {
        })
        .finally(() => loading.value = false)
  }

  
  function initForm(nps){
    
  }
  
  onMounted(() => {
    if(route.params.id){
      loadNps()
    }
  })
  
  </script>
  
  <style scoped>
  .password-input {
    position: relative;
  }
  
  .toggle-password {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
  }
  
  #eye-icon {
    font-size: 1.2em;
  }
  </style>
  